import axios from "axios";

/**
 * @classdesc Une transaction a rembourser
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Transaction_Refund
 */
export default class Transaction_Refund {
    id;
    paye;
    prix = 0;
    statut;
    uuid;
    amount_to_refund = 0;
    total_after_refund = 0;
    captured = false;

    /**
     * Creates an instance of Transaction_Refund.
     * @constructs
     * @kind function
     * @memberof Transaction_Refund
     */
    constructor() { }



    set(data) {
        this.id = data.id;
        this.paye = data.paye;
        this.prix = data.prix;
        this.statut = data.statut;
        this.uuid = data.uuid;
        this.total_after_refund = parseFloat(this.prix) - parseFloat(this.amount_to_refund);
    }

    async is_captured() {
        let res = await axios.post("/lyra_payment/get_transaction.php", { transaction_uuid: this.uuid });
        if (res.data.error) {
            console.log(res.data.error);
        } else {
            this.captured = res.data.answer.detailedStatus == "CAPTURED";
        }
    }
}